import { SuspenseHandler } from './packages/suspense-handler';
export const createReactSuspenseHandling = () => SuspenseHandler;